/**
 */

define('task-evaluate',['knockout'], function(ko) {
    'use strict';

    return function(parentVM, dataContext) {
        var self = this,
            trainingVM = parentVM.training,
            entityVM = parentVM.entity;

        self.tiltLabels = ko.observable(true);

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.labelWidth = function(index){
            var answers = trainingVM.sliderAnswers();

            if (self.tiltLabels()){
                if(index < answers.length - 1){
                    return 90 / (answers.length - 1);
                }else{
                    return 10;
                }
            }else{
                return 100 / answers.length;
            }
        };

        self.sliderWidth = function() {
            var answers = entityVM.answersJS(),
                lastLabel = (entityVM.showDontKnowOption()) ? entityVM.answerNoOpinionCaption() : answers[answers.length-1].text;

            if (self.tiltLabels()){
                return 100 - lastLabel.length;
            }else{
                return 100;
            }
        };

        ko.bindingHandlers.taskEvaluate = {
            update: function () {
                self.tiltLabels(trainingVM.getComponentParamValuesByName('tiltLabels')[0] !== false);

            }
        };
    }
});


